import React from "react";

const RTFRTextBlock = ({
  title,
  paragraphs = [],
  variant = "",
  image,
  imageAlt = "",
  imageSide = "right",
}) => {
  const cls = ["rtfr-text-section", variant ? `rtfr-text-section--${variant}` : ""]
    .filter(Boolean)
    .join(" ");

  // Plain full-width text layout (no image)
  if (!image) {
    return (
      <section className={cls}>
        <div className="container">
          <h2
            className="rtfr-text-title"
            data-aos="fade-up"
            data-aos-once="true"
          >
            {title}
          </h2>

          {paragraphs.map((p, i) => (
            <p
              key={i}
              className="rtfr-text-para"
              data-aos="fade-up"
              data-aos-delay={`${(i + 1) * 80}`}
              data-aos-once="true"
            >
              {p}
            </p>
          ))}
        </div>
      </section>
    );
  }

  // Two-column image + content layout
  const contentCol = (
    <div
      className="col-lg-6 d-flex flex-column justify-content-center"
      data-aos={imageSide === "right" ? "fade-right" : "fade-left"}
      data-aos-duration="1200"
      data-aos-once="true"
    >
      <h2 className="rtfr-text-title">{title}</h2>
      {paragraphs.map((p, i) => (
        <p key={i} className="rtfr-text-para">{p}</p>
      ))}
    </div>
  );

  const imageCol = (
    <div
      className="col-lg-6 mt-4 mt-lg-0"
      data-aos={imageSide === "right" ? "fade-left" : "fade-right"}
      data-aos-duration="1200"
      data-aos-once="true"
    >
      <div className="rtfr-text-img-wrapper">
        <img src={image} alt={imageAlt} className="rtfr-text-img" loading="lazy" />
      </div>
    </div>
  );

  return (
    <section className={cls}>
      <div className="container">
        <div className="row g-4 g-lg-5 align-items-stretch">
          {imageSide === "left" ? (
            <>
              {imageCol}
              {contentCol}
            </>
          ) : (
            <>
              {contentCol}
              {imageCol}
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default RTFRTextBlock;
